<template>
    <DataTable
        :value="domains"
        v-if="domains"
        selectionMode="single"
        @row-click="
            (event: DataTableRowClickEvent) => {
                // Forward the click to the router link inside.
                (event.originalEvent.target as HTMLElement)
                    .querySelector('a')
                    ?.click();
            }
        "
    >
        <template #header>
            <div style="display: flex; justify-content: space-between">
                <h2>Domains</h2>
                <Button
                    class="p-button-secondary"
                    icon="pi pi-plus"
                    label="Add domain"
                    severity="secondary"
                    text
                    @click="openNewDomainDialog()"
                />
            </div>
        </template>

        <template #empty>
            <div>No domains</div>
        </template>
        <Column field="name" header="Name">
            <template #body="{ data, field }">
                <RouterLink
                    class="domain-link"
                    :to="{
                        name: 'domainPage',
                        params: {
                            orgName: route.params.orgName,
                            stekName: route.params.stekName,
                            domainId: data.identity,
                        },
                    }"
                >
                    <div>
                        {{ data[field] }}
                    </div>
                </RouterLink>
            </template>
        </Column>
    </DataTable>
</template>

<script setup lang="ts">
import type { DataTableRowClickEvent } from "primevue/datatable";
import type { DomainInTree } from "@/stores/domains-store";
import NewDomain from "./NewDomain.vue";
import { useRoute } from "vue-router";
import { useDialog } from "primevue/usedialog";

defineProps<{
    domains: DomainInTree[];
}>();

const route = useRoute();
const dialog = useDialog();

const openNewDomainDialog = () => {
    dialog.open(NewDomain, {
        props: {
            header: "New domain",
            style: {
                maxWidth: "600px",
                width: "80%",
            },
            modal: true,
            maximizable: false,
            draggable: false,
        },
    });
};
</script>

<style>
.domain-link {
    text-decoration: none;
}
</style>
